import { Component, OnInit, Input, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MainAPiServiceService } from '@_services/main-api-service.service';
import { BehaviorService } from '@_services/Behavior.service';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-reginoal-setting',
  templateUrl: './reginoal-setting.component.html',
  styleUrls: ['./reginoal-setting.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ReginoalSettingComponent implements OnInit, OnDestroy {
  @Input() errorWarningData: any;
  @Input() SettingForm: FormGroup;
  currentuser = JSON.parse(localStorage.getItem('currentUser'));
  @Input() getDropDownValue;
  sub: Subscription;
  public isspiner: boolean = false;
  private _unsubscribeAll$: Subject<void> = new Subject();
  // getDropDownValue: any = [];
  timeZoneData: any = [
    { Name: '(UTC +08:00) Perth', value: '(UTC +08:00) Perth' },
    { Name: '(UTC +09:30) Adelaide', value: '(UTC +09:30) Adelaide' },
    { Name: '(UTC +09:30) Darwin', value: '(UTC +09:30) Darwin' },
    { Name: '(UTC +10:00) Brisbane', value: '(UTC +10:00) Brisbane' },
    {
      Name: '(UTC +10:00) Canberra, Melbourne, Sydney',
      value: '(UTC +10:00) Canberra, Melbourne, Sydney',
    },
    { Name: '(UTC +10:00) Hobart', value: '(UTC +10:00) Hobart' },
    {
      Name: '(UTC +11:00) New Caledonia, Norfolk Island, Solomon Islands',
      value: '(UTC +11:00) New Caledonia, Norfolk Island, Solomon Islands',
    },
    {
      Name: '(UTC +12:00) Auckland, Wellington',
      value: '(UTC +12:00) Auckland, Wellington',
    },
  ];
  countryList: any = [];
  constructor(
    private _mainAPiServiceService: MainAPiServiceService,
    private behaviorService: BehaviorService,
    private toastr: ToastrService,
  ) {
    localStorage.setItem('istrackid', 'SystemSettingReginoalSettingComponent');
  }

  /**
   * It runs once after the component's view has been fully initialized.
   */
  ngOnInit() {
    // this._mainAPiServiceService.getSetData({EXCLUDESYSTEMACCOUNTS :true,EXCLUDEINVOICETEMPLATESETTINGS:true}, 'GetSystem').subscribe(response => {
    //   this.getDropDownValue = response.DATA.LISTS;
    // });
    let CountryListLookups = localStorage.getItem('country_list_lookups');
    if (CountryListLookups && CountryListLookups != 'null') {
      this.countryList = JSON.parse(CountryListLookups);
      this.behaviorService.loadingSystemSetting('regional-setting');
    } else {
      this.sub = this._mainAPiServiceService
        .getSetData(
          {
            Action: 'getdata',
            Filters: { LookupType: 'Country List' },
          },
          'lookup',
        )
        .subscribe((responses) => {
          if (responses.CODE === 200 && responses.STATUS === 'success') {
            this.countryList = responses.DATA.LOOKUPS;
            localStorage.setItem('country_list_lookups', JSON.stringify(responses.DATA.LOOKUPS));
            this.behaviorService.loadingSystemSetting('regional-setting');
          }
        });
    }
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
    this._unsubscribeAll$.next();
    this._unsubscribeAll$.complete();
  }

  /**
   * save the data of particular region
   */
  saveReginSetting() {
    this.isspiner = true;
    let data = {
      GroupName: 'BusinessSetup',
      SubgroupName: 'Region',
      COUNTRY: this.SettingForm.controls.COUNTRY.value,
      CURRENCYSYMBOL: this.SettingForm.controls.CURRENCYSYMBOL.value,
      TIMEZONE: this.SettingForm.controls.TIMEZONE.value,
      TAXTYPE: this.SettingForm.controls.TAXTYPE.value,
      TAXRATE: this.SettingForm.controls.TAXRATE.value,
    };

    let data1 = { Action: 'Update', Data: data };
    (this._mainAPiServiceService
      .getSetData(data1, 'system')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe((response) => {
        if (response.CODE == 200 && (response.STATUS == 'OK' || response.STATUS == 'success')) {
          this.isspiner = false;
          this.behaviorService.DELIVERABLES$.next(localStorage.getItem('set_active_DELIVERABLES'));
          localStorage.setItem(
            'set_active_CURRENCYSYMBOL',
            JSON.stringify(
              this.SettingForm.controls.CURRENCYSYMBOL?.value
                ? this.SettingForm.controls.CURRENCYSYMBOL?.value
                : '',
            ),
          );
          this.currentuser['TAXRATE'] = this.SettingForm.controls.TAXRATE.value;
          localStorage.setItem('currentUser', JSON.stringify(this.currentuser));
          this.behaviorService.setCURRENCYSYMBOL(this.SettingForm.controls.CURRENCYSYMBOL.value);
          this.toastr.success('Updated successfully');
        } else if ((response.CODE == 451 || response.CODE == 450) && response.STATUS == 'warning') {
          this.isspiner = false;
          this.toastr.warning(response.MESSAGE);
        } else if ((response.CODE == 450 || response.CODE == 451) && response.STATUS == 'error') {
          this.isspiner = false;
          this.toastr.warning(response.MESSAGE);
        } else {
          this.isspiner = false;
        }
      }),
      (error) => {
        this.isspiner = false;
        this.toastr.error(error);
      });
  }
}
